module.exports = __webpack_public_path__ + "img/smirnoff.9b000e0c.gif";